import { Icon, type IconName, Text } from '@iconik-io/uad';

import styles from './comment_type_menu_item.module.css';

export type CommentTypeItemProps = {
  label: string;
  helpMessage: string;
  icon?: IconName;
};

export function CommentTypeMenuItem({
  label,
  helpMessage,
  icon,
}: CommentTypeItemProps) {
  return (
    <div className={styles.container}>
      {icon ? <Icon name={icon} /> : null}
      <div className={styles.item}>
        <Text color="inherit" variant="value">
          {label}
        </Text>
        <Text variant="label">{helpMessage}</Text>
      </div>
    </div>
  );
}
